import React, { useState } from 'react'
import { useUserAuth } from '../../Context/userAuthContext';
import { isUser } from '../../Config/isUser';


const UserNavbar = () => {
  const { logout } = useUserAuth();
  const [nav , setNav] = useState(false);
  const [navBiyomed , setNavBiyomed] = useState(false);
  const [navUser , setNavUser] = useState(false);
  const loginType = "user"
  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await logout(loginType); 
    } catch (err) {
      console.log(err.message); // Hata durumunda kullanıcıya mesaj gösterme
    }
  };

      const [search_term, setSearch_term] = useState('');
      const handleChange = (e) => {
        e.preventDefault();
        const { value } = e.target;
        setSearch_term(value)
      }
      const handleSubmit= (e) => {
        e.preventDefault();
        window.location.href= isUser ? `/search-posts/${search_term}` : '/login'
      }

      const handleNavClick = (e)=>{
        e.preventDefault();
        setNav(!nav)
      }
      const handleNavBiyomedClick = (e)=>{
        e.preventDefault();
        setNavBiyomed(!navBiyomed)
      }
      const handleNavUserClick = (e)=>{
        e.preventDefault();
        setNavUser(!navUser)
      }

  return (
<div className="gc_main_menu_wrapper" >
  <div className="container-fluid" >
    <div className="row">
      <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 hidden-xs hidden-sm full_width">
      <div className="gc_header_wrapper">
          <div style={{marginTop:-10, marginLeft:10}} className="gc_logo">
            <a href="/">
              <img
                src="https://biyomed.net/kariyer_images/biyomedlogosiyahzemin2.png"
                alt="Logo"
                title="Biyomed Kariyer"
                className="img-responsive"
              />
            </a>
          </div>
        </div>
      </div>
      <div className="col-lg-7 col-md-8 col-sm-12 col-xs-12 center_responsive">
        <div className="header-area hidden-menu-bar stick" id="sticker">
          {/* mainmenu start */}
          <div className="mainmenu">
          {/* <div className="gc_right_menu">
              <ul>
                <li onClick={() => setOpenSearch(!openSearch)} >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Capa_3"
                    x="0px"
                    y="0px" 
                    viewBox="0 0 451 451"
                    style={{ enableBackground: "new 0 0 451 451", marginRight: 3 }}
                    xmlSpace="preserve"
                  >
                    <g>
                      <path
                      
                        id="search"
                        d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3   s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4   C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3   s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z"
                        fill="#23c0e9"
                      />
                    </g>
                  </svg>
                </li>
                <li>
                <div className="gc_search_box" style={{ display: openSearch ? 'block' : 'none' }}>
                  <input  type="text" placeholder="Search here" />
                    <button >
                      <i onClick={() => setOpenSearch(!openSearch)} className="fa fa-search"  />
                    </button>
                  </div>
                </li>
              </ul>
            </div> */}
            <ul className="float_left">
            <li className="has-mega gc_main_navigation">
                <a href="/" className="gc_main_navigation">
                  {" "}
                  Anasayfa
                </a>
                {/* mega menu start */}

              </li>
              <li className="parent gc_main_navigation">
                <a href="/" className="gc_main_navigation">
                İlanlar &nbsp;
                  <i className="fa fa-angle-down" />
                </a>
                {/* sub menu start */}
                <ul>
                  <li className="parent">
                    <a href="/all-posts">Tüm İlanlar</a>
                  </li>
                  <li className="parent">
                    <a href="/my-applied-posts">Başvurduğum İlanlar</a>
                  </li>
                </ul>
                {/* sub menu end */}
              </li>
              <li className="has-mega gc_main_navigation">
                <a href="/" className="gc_main_navigation">
                  {" "}
                  Biyomed&nbsp;
                  <i className="fa fa-angle-down" />
                </a>
                {/* mega menu start */}
                <ul>
                  <li className="parent">
                    <a href="https://www.biyomed.org.tr/">Hakkımızda</a>
                  </li>
                  <li className="parent">
                    <a href="https://www.biyomed.org.tr/">Nasıl Üye Olurum?</a>
                  </li>
                </ul>
              </li>
              <li className="gc_main_navigation parent">
                <a href="/blogs" className="gc_main_navigation">
                Blog
                </a>
              </li>
              <li className="gc_main_navigation parent">
                <a href="contact" className="gc_main_navigation">
                İletişim
                </a>
              </li>
            </ul>
          </div>
          {/* mainmenu end */}
          {/* mobile menu area start */}
          <header className="mobail_menu">
            <div className="container-fluid">
              <div className="row">
                <div className="col-xs-6 col-sm-6">
                  <div style={{marginTop:0}} className="gc_logo">
                    <a href="/">
                      <img
                      style={{maxWidth:200,maxHeight:"100%"}}
                        src="https://biyomed.net/kariyer_images/biyomedlogosiyahzemin2.png"
                        alt="Logo"
                        title="Grace Church"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-xs-6 col-sm-6">
                  <div className="cd-dropdown-wrapper">
                  <a className={nav ? "house_toggle dropdown-is-active" :"house_toggle" } href="/"  onClick={(e) => handleNavClick(e)}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 31.177 31.177"
                        style={{ enableBackground: "new 0 0 31.177 31.177" }}
                        xmlSpace="preserve"
                        width="25px"
                        height="25px"
                      >
                        <g>
                          <g>
                            <path
                              className="menubar"
                              d="M30.23,1.775H0.946c-0.489,0-0.887-0.398-0.887-0.888S0.457,0,0.946,0H30.23    c0.49,0,0.888,0.398,0.888,0.888S30.72,1.775,30.23,1.775z"
                              fill="#ffffff"
                            />
                          </g>
                          <g>
                            <path
                              className="menubar"
                              d="M30.23,9.126H12.069c-0.49,0-0.888-0.398-0.888-0.888c0-0.49,0.398-0.888,0.888-0.888H30.23    c0.49,0,0.888,0.397,0.888,0.888C31.118,8.729,30.72,9.126,30.23,9.126z"
                              fill="#ffffff"
                            />
                          </g>
                          <g>
                            <path
                              className="menubar"
                              d="M30.23,16.477H0.946c-0.489,0-0.887-0.398-0.887-0.888c0-0.49,0.398-0.888,0.887-0.888H30.23    c0.49,0,0.888,0.397,0.888,0.888C31.118,16.079,30.72,16.477,30.23,16.477z"
                              fill="#ffffff"
                            />
                          </g>
                          <g>
                            <path
                              className="menubar"
                              d="M30.23,23.826H12.069c-0.49,0-0.888-0.396-0.888-0.887c0-0.49,0.398-0.888,0.888-0.888H30.23    c0.49,0,0.888,0.397,0.888,0.888C31.118,23.43,30.72,23.826,30.23,23.826z"
                              fill="#ffffff"
                            />
                          </g>
                          <g>
                            <path
                              className="menubar"
                              d="M30.23,31.177H0.946c-0.489,0-0.887-0.396-0.887-0.887c0-0.49,0.398-0.888,0.887-0.888H30.23    c0.49,0,0.888,0.398,0.888,0.888C31.118,30.78,30.72,31.177,30.23,31.177z"
                              fill="#ffffff"
                            />
                          </g>
                        </g>
                      </svg>
                    </a>
                    <nav className={nav ? "cd-dropdown dropdown-is-active": "cd-dropdown" }>
                      <h2>
                        <a href="/">
                          Biyo<span>Med</span>
                        </a>
                      </h2>
                      <a href="/" className="cd-close"  onClick={(e) => handleNavClick(e)}>
                        Close
                      </a>
                      <ul className={navBiyomed || navUser ? "cd-dropdown-content move-out" : "cd-dropdown-content"}>
                        <li>
                          <form onSubmit={handleSubmit} className="cd-search">
                            <input type="search" onChange={handleChange}  placeholder="İlanlarda ara..." />
                          </form>
                        </li>
                        <li>
                          <a href="/">Anasayfa</a>
                        </li>
                        <li className="has-children">
                        <a onClick={(e)=>handleNavUserClick(e)} href="/">İlanlar</a>
                        <ul className={navUser ? "cd-secondary-dropdown " : "cd-secondary-dropdown is-hidden"}>
                            <li className="go-back">
                            <a href="/0" onClick={(e)=>handleNavUserClick(e)}>Menu</a>
                            </li>
                            <li>
                              <a href="/all-posts">Tüm ilanlar</a>
                            </li>
                            <li>
                              <a href="/my-applied-posts">Başvurduğum ilanlar</a>
                            </li>
                            {/* .has-children */}
                          </ul>
                          {/* .cd-secondary-dropdown */}
                        </li>
                        <li className="has-children">
                          <a onClick={(e)=>handleNavBiyomedClick(e)} href="/">Biyomed</a>
                          <ul className={navBiyomed ? "cd-secondary-dropdown " : "cd-secondary-dropdown is-hidden"}>
                            <li className="go-back">
                            <a href="/0" onClick={(e)=>handleNavBiyomedClick(e)}>Menu</a>
                            </li>
                            <li>
                              <a href="https://www.biyomed.org.tr/">Hakkımızda</a>
                            </li>
                            <li>
                              <a href="https://www.biyomed.org.tr/">Nasıl Üye Olurum?</a>
                            </li>
                            {/* .has-children */}
                          </ul>
                          {/* .cd-secondary-dropdown */}
                        </li>
                        <li>
                          <a href="/blogs">Blog</a>
                        </li>
                        <li>
                          <a href="/contact">İletişim</a>
                        </li>
                        <li>
                        <a href="/userprofile">Hesabım</a>
                        </li>
                        <li>
                        <a onClick={handleLogout} href="/">Çıkış Yap</a>
                        </li>
                      </ul>
                      {/* .cd-dropdown-content */}
                    </nav>
                    {/* .cd-dropdown */}
                  </div>
                </div>
              </div>
            </div>
            {/* .cd-dropdown-wrapper */}
          </header>
        </div>
      </div>
      {/* mobile menu area end */}
      <div className="col-lg-3 col-md-4 col-sm-12 col-xs-12 hidden-sm hidden-xs">
        <div className="jp_navi_right_btn_wrapper">
          <ul>
            <li>
              <a href="/userprofile">
                <i className="fa fa-user" />
                &nbsp; Hesabım
              </a>
            </li>
            <li onClick={handleLogout}>
              <a href="/login">
                <i className="fa fa-sign-in" />
                &nbsp; Çıkış Yap
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>


  )
}

export default UserNavbar